import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../store/authStore'
import { supabase } from '../lib/supabase'

export const useSubscription = () => {
  const user = useAuthStore((s) => s.user)

  return useQuery({
    queryKey: ['subscription', user?.id],
    enabled:  !!user?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle()
      if (error) throw error
      // Return a default free subscription shape if no record exists yet
      return data ?? { plan: 'free', status: 'active', current_period_end: null, billing_cycle: null, is_comped: false }
    },
  })
}
